import { useEffect, useState } from 'react';
import { responseSuccess } from 'helper/responseSuccess/responseSuccess';
import { apiOperatorGetCompanyDirectDebit } from 'api/operator';

export interface ICompanyPairedResponse {
  id: number;
  name: string;
  code: string;
  status: number;
  created_at: string;
  updated_at: string;
}

const SelectCompanyPairedWithDirectDebit = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [listCompanyPaired, setListCompanyPaired] = useState<ICompanyPairedResponse | any>([]);

  //   const handleScrollBank = (e: any) => {
  //     const element = e.target;
  //     const conditionCall = element.scrollHeight - element.clientHeight - element.scrollTop;
  //     if (conditionCall <= 10) {
  //       console.log(conditionCall);
  //     }
  //   };

  const getListCompanyDirectDebit = async () => {
    try {
      setIsLoading(true);
      // if (companyId === undefined) return [];
      const response = await apiOperatorGetCompanyDirectDebit({});
      if (responseSuccess(response)) {
        setListCompanyPaired(
          response.data.map((element: ICompanyPairedResponse) => {
            return {
              ...element,
              value: element.code,
              label: `${element.name} (${element.code})`,
            };
          })
        );
      }
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getListCompanyDirectDebit();
  }, []);

  return { listCompanyPaired, getListCompanyDirectDebit, isLoading };
};

export default SelectCompanyPairedWithDirectDebit;
